import { postWithJson } from 'library/utils/serviceUtil'

// 查询
export const queryReportBranchType = params => postWithJson('/businessBudget/queryReportHeadTypeDept.json', params)

// 归档 1归档 2取消归档 3导出 4查询
export const archiveReportBranchType = params => postWithJson('/businessBudget/archiveReportHeadTypeDept.json', params)

// 导出
export const exportReportBranchType = params => postWithJson('/businessBudget/exportReportHeadTypeDept.json', params)